import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogOut, LayoutDashboard, ExternalLink, Sparkles, Video, Mail, Send } from "lucide-react";
import { useAdminAuth } from "@/lib/AdminAuthContext";

export default function AdminLayout({ children }) {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const onLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#f9f6f0]">
      <header className="bg-[#1a2421] text-[#f9f6f0]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full border border-[#bc6c25] grid place-items-center font-serif italic text-[#bc6c25]">E</div>
            <div>
              <p className="font-serif text-lg leading-none">Eliora <em className="text-[#bc6c25]">CRM</em></p>
              <p className="text-[10px] uppercase tracking-[0.22em] text-[#f9f6f0]/50 mt-0.5">
                Panel privado · {admin?.name || "Sarai"}
              </p>
            </div>
          </Link>

          <nav className="flex items-center gap-3 text-sm">
            <Link
              to="/admin"
              data-testid="nav-dashboard"
              className={`px-3 py-1.5 rounded-full transition-colors flex items-center gap-2 ${
                location.pathname === "/admin"
                  ? "bg-[#bc6c25] text-white"
                  : "text-[#f9f6f0]/70 hover:text-[#f9f6f0]"
              }`}
            >
              <LayoutDashboard className="w-3.5 h-3.5" />
              Dashboard
            </Link>
            <Link
              to="/admin/studio"
              data-testid="nav-studio"
              className={`px-3 py-1.5 rounded-full transition-colors flex items-center gap-2 ${
                location.pathname === "/admin/studio"
                  ? "bg-[#bc6c25] text-white"
                  : "text-[#f9f6f0]/70 hover:text-[#f9f6f0]"
              }`}
            >
              <Sparkles className="w-3.5 h-3.5" />
              Studio
            </Link>
            <Link
              to="/admin/reels"
              data-testid="nav-reels"
              className={`px-3 py-1.5 rounded-full transition-colors flex items-center gap-2 ${
                location.pathname === "/admin/reels"
                  ? "bg-[#bc6c25] text-white"
                  : "text-[#f9f6f0]/70 hover:text-[#f9f6f0]"
              }`}
            >
              <Video className="w-3.5 h-3.5" />
              Reels
            </Link>
            <Link
              to="/admin/newsletter"
              data-testid="nav-newsletter"
              className={`px-3 py-1.5 rounded-full transition-colors flex items-center gap-2 ${
                location.pathname === "/admin/newsletter"
                  ? "bg-[#bc6c25] text-white"
                  : "text-[#f9f6f0]/70 hover:text-[#f9f6f0]"
              }`}
            >
              <Mail className="w-3.5 h-3.5" />
              Newsletter
            </Link>
            <Link
              to="/admin/broadcast"
              data-testid="nav-broadcast"
              className={`px-3 py-1.5 rounded-full transition-colors flex items-center gap-2 ${
                location.pathname === "/admin/broadcast"
                  ? "bg-[#bc6c25] text-white"
                  : "text-[#f9f6f0]/70 hover:text-[#f9f6f0]"
              }`}
            >
              <Send className="w-3.5 h-3.5" />
              Broadcast
            </Link>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-3 py-1.5 rounded-full text-[#f9f6f0]/70 hover:text-[#f9f6f0] flex items-center gap-2"
            >
              <ExternalLink className="w-3.5 h-3.5" />
              Ver sitio
            </a>
            <button
              onClick={onLogout}
              data-testid="admin-logout-btn"
              className="px-3 py-1.5 rounded-full bg-[#f9f6f0]/5 text-[#f9f6f0]/70 hover:text-[#f9f6f0] hover:bg-[#f9f6f0]/10 flex items-center gap-2"
            >
              <LogOut className="w-3.5 h-3.5" />
              Salir
            </button>
          </nav>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-10">{children}</main>
    </div>
  );
}
